import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { getAllResearchKpis } from 'apis/projectProposals.api';

const useGetResearchKpis = (appliedYear, conds) => {
  const { data: researchKpisData, ...rest } = useQuery(
    ['projectProposalResearchKpis', appliedYear],
    () => getAllResearchKpis({ appliedYear }),
    {
      ...conds,
    }
  );

  const researchKpis = useMemo(() => researchKpisData?.data ?? [], [researchKpisData]);

  return {
    data: researchKpis,
    ...rest,
  };
};

export default useGetResearchKpis;
